import axios from 'axios';

const http = axios.create({ baseURL: '/api/v1' });

// http.js can't import the Pinia auth store directly (store -> api wrappers -> http.js
// would become circular), so the app wires up the real handler once at boot via
// setUnauthorizedHandler — see main.js. This keeps the redirect an in-app router
// navigation instead of a hard reload that would drop the user's current route.
let unauthorizedHandler = null;
let unauthorizedHandled = false;

export function setUnauthorizedHandler(handler) {
  unauthorizedHandler = handler;
}

http.interceptors.request.use((config) => {
  const token = localStorage.getItem('bm_token');
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

http.interceptors.response.use(
  (res) => res,
  (err) => {
    if (err.response?.status === 401 && !unauthorizedHandled) {
      // Multiple requests can 401 in the same burst (e.g. two concurrent fetches on
      // an expired token) — only react to the first; reset on the next tick so a
      // later, genuinely new 401 (after re-login) still triggers the handler.
      unauthorizedHandled = true;
      setTimeout(() => { unauthorizedHandled = false; }, 0);
      unauthorizedHandler?.();
    }
    return Promise.reject(err.response?.data?.error || { message: err.message });
  },
);

export default http;
